import React, { useEffect } from 'react';
import { useFormikContext } from 'formik';
import SentenceCompletion from '~/admin/components/questions/SentenceCompletion.jsx';
import { buildSentenceProps } from '~/app/adapters/questionAdapters';

export default function FieldSentenceCompletion({
  question: q, qIndex, disabled = false, showAns = false,
  resetSignal, showReset = true,
}) {
  const { setFieldValue, values } = useFormikContext();
  const { tokens, sentence, answers } = buildSentenceProps(q);

  const handleChange = (report) => {
    console.log('[FieldSentenceCompletion] onChange report', { report });
    const texts = (report && report.slotAnswers) ? report.slotAnswers.map((txt) => {
      if (!txt || String(txt).trim() === '') return null;
      return String(txt);
    }) : [];
    console.log('[FieldSentenceCompletion] mapped-texts', { texts });
    // schedule Formik update asynchronously to avoid updating Formik during render of child
    Promise.resolve().then(() => {
      let targetIndex = qIndex;
      if (values && Array.isArray(values.answers)) {
        const found = values.answers.findIndex((a) => String(a && a.question) === String(q && q._id));
        if (found >= 0) targetIndex = found;
      }
      setFieldValue(`answers.${targetIndex}.answeredSeq`, texts);
      console.log('[FieldSentenceCompletion] form values snippet', { answersRow: values.answers && values.answers[targetIndex] });
    });
  };

  return (
    <SentenceCompletion
      items={tokens}
      sentence={sentence}
      answers={answers}
      onChange={handleChange}
      value={null}
      restrictEdit={disabled}
      resetSignal={resetSignal}
      showExpected={showAns}
      showReset={showReset}
      showAns={true}
    />
  );
}
